<div class="page-title-area page-title-area-three title-img-one">
    <div class="d-table">
        <div class="d-table-cell">
            <div class="page-title-text">
                <h2>About Our Firm</h2>

                <ul>
                    <li><a [routerLink]="routeUrls.homeUrl">Home</a></li>
                    <li><i class="icofont-simple-right"></i></li>
                    <li>About Us</li>
                </ul>

                <div class="page-title-btn">
                    <a [routerLink]="routeUrls.practiceUrl">ALL PRACTICES<i class="icofont-arrow-right"></i></a>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="help-area help-area-two pb-70" style="margin: 3%;">
    <div class="container-fluid">
        <div class="row align-items-center">
            <div class="col-lg-6">
                <div class="help-item" style="margin-left: 8%;">
                    <img src="assets/img/Main-layout/home-3.jpg" height="700px" style="border: 20px solid #b69d74;" alt="Help">
                </div>
            </div>
            <div class="col-lg-6">
                <div class="help-item">
                    <div class="help-right">
                        <h2>We Provide Professional Attorneys to Assist You</h2>
                        <p style="margin-bottom:0;">Walayet & Associates (LLP®) aims to be the most innovative law firm by establishing long-term and friendly 
                            relationships with its valued clients, based on the principles of honesty, reciprocity, trust, and the highest 
                            standards of professional ethics. By adopting new and modern models for the delivery of legal services, we strive 
                            to redefine the role that a law firm and a lawyer play in an emerging market to achieve exceptional results for the 
                            clients. Walayet & Associates (LLP®) believes in absolute commitment to representing our client’s interests and takes 
                            pride in protecting our clients’ rights. Thorough legal research and case preparation, honest, dedicated advice, and experienced 
                            advocacy based on an in-depth knowledge of the law are the hallmarks of the Walayet & Associates (LLP®) team. The sole measures of 
                            our success are concrete results and client satisfaction. The provision of a broad range of legal services </p><span class="custom-pointer" *ngIf = "isReadMore" (click)="showContent()">{{readContent}}</span><p *ngIf = "!isReadMore" style="margin : 0; padding-top:0;">to such a diverse clientele 
                            allows us to bring innovations towards solving complex legal issues. The solutions we provide to our clients are comprehensive, innovative, 
                            and most importantly viable. Walayet & Associates (LLP®) has the expertise in all types of Alternate Dispute Resolutions, Arbitration Matters, 
                            litigation, from Civil Court to the Honourable Supreme Court of Pakistan also in Courts and Tribunals governed under the special laws, including 
                            but not limited to, Trademark, Copyright, and Patents Registration from Intellectual Property Organization (IPO), Consultancy, and Litigation 
                            regarding their infringement. We also provide a complete guide for new Start-Ups like new company registration and consultancy, SECP cases, inquiries, 
                            and replies to notices. We also have an experienced team for dealing with family cases i.e., Divorce, Khulla, Child Custody, Maintenance, Second Marriage. 
                            Another area of our expertise is Taxation Laws as Walayet & Associates (LLP®) has a best-experienced team for Income Tax Filing, Sales Tax Filing, 
                            and Replies of Notices of FBR, Filing of Appeals before Commissioners and Appellate Tribunal, and filing of Writ Petitions in High Court. 
                            This blend of the exceptionally trained and experienced team coupled with an in-depth knowledge of the laws places us in a unique position in the market.</p>
                            <span class="custom-pointer" (click)="readLess()" *ngIf = "!isReadMore">{{readContent}}</span>

                        <br />
                        <div class="help-inner-left">
                            <ul>
                                <li>
                                    <i class="flaticon-checkmark"></i> Browse Our Website</li>
                                <li><i class="flaticon-checkmark"></i> Choose Services</li>
                            </ul>
                        </div>

                        <div class="help-inner-right">
                            <ul>
                                <li><i class="flaticon-checkmark"></i> Quick Reply</li>
                                <li><i class="flaticon-checkmark"></i> Best Performances</li>
                            </ul>
                        </div>

                        <div class="help-signature">
                            <img src="assets/img/about/sign.png" alt="Signature" height="130px">
                        </div>
                        <h3>MALIK SAQIB MEHMOOD KHALID</h3>
                        <span>PARTNER</span>
                    </div>
                </div>
            </div>
        </div>

        <div class="row align-items-center help-wrap">
            <div class="col-lg-6">
                <div class="help-item">
                    <div class="help-right">
                        <h2>Our Attorneys Always Provide The Excellent Service</h2>
                        <p>Teams of  Intelligent & Professional Attorneys are always prepared to make you triumph. We always try our best to make our clients happy.</p>

                        <div class="help-inner-left">
                            <ul>
                                <li><i class="flaticon-checkmark"></i> On Time Response</li>
                                <li><i class="flaticon-checkmark"></i> Legal Way</li>
                            </ul>
                        </div>

                        <div class="help-inner-right">
                            <ul>
                                <li><i class="flaticon-checkmark"></i> Legal Services</li>
                                <li><i class="flaticon-checkmark"></i> Honest Work</li>
                            </ul>
                        </div>

                        <a class="cmn-btn" [routerLink]="routeUrls.practiceUrl">Learn More</a>
                    </div>
                </div>
            </div>

            <div class="col-lg-6">
                <div class="help-item" style="margin-right: 8%;">
                    <img src="assets/img/Main-layout/home-4.jpg" style="border: 20px solid #b69d74;" alt="Help">
                </div>
            </div>
        </div>

        <div class="help-shape">
            <img src="assets/img/home-one/6.png" alt="Shape">
        </div>
    </div>
</div>

<section class="expertise-area expertise-area-two pt-100 pb-70">
    <div class="container">
        <div class="section-title">
            <!-- <span>OUR EXPERTISE</span> -->
            <h2>Law Firm Devoted To Our Clients</h2>
        </div>

        <div class="row align-items-center">
            <div class="col-lg-6">
               <div class="expertise-item">
                    <ul>
                        <li class="wow fadeInUp" data-wow-delay=".3s">
                            <div class="expertise-icon">
                                <i class="flaticon-experience"></i>
                                <img src="assets/img/home-one/11.png" alt="Shape">
                            </div>
                            <h3>Experience</h3>
                            <p>Our teams are exceptionally skilled, acknowledge their client’s condition & help them to achieve their target.</p>
                        </li>

                        <li class="wow fadeInUp" data-wow-delay=".4s">
                            <div class="expertise-icon">
                                <i class="flaticon-lawyer"></i>
                                <img src="assets/img/home-one/11.png" alt="Shape">
                            </div>
                            <h3>Skilled Attorney</h3>
                            <p>Our attorneys are innovative and knowledgeable and help clients pursue a vast number of solutions to succeed.</p>
                        </li>

                        <li class="wow fadeInUp" data-wow-delay=".5s">
                            <div class="expertise-icon">
                                <i class="flaticon-balance"></i>
                                <img src="assets/img/home-one/11.png" alt="Shape">
                            </div>
                            <h3>Legal Proces</h3>
                            <p>We maintain all valid papers and paperwork and continue to meet our destination legally.</p>
                        </li>
                    </ul>
               </div>
            </div>

            <div class="col-lg-6">
               <div class="expertise-item">
                    <ul>
                        <li class="wow fadeInUp" data-wow-delay=".3s">
                            <div class="expertise-icon">
                                <i class="flaticon-money-bag"></i>
                                <img src="assets/img/home-one/11.png" alt="SLyzohape">
                            </div>
                            <h3>Low Cost</h3>
                            <p>Our team is exceptionally skilled, realize their client’s condition, help them to achieve their motive.</p>
                        </li>

                        <li class="wow fadeInUp" data-wow-delay=".4s">
                            <div class="expertise-icon">
                                <i class="flaticon-time"></i>
                                <img src="assets/img/home-one/11.png" alt="Shape">
                            </div>
                            <h3>Good Performance</h3>
                            <p>Our attorneys are creative and knowledgeable and support clients by finding numerous solutions to win.</p>
                        </li>

                        <li class="wow fadeInUp" data-wow-delay=".5s">
                            <div class="expertise-icon">
                                <i class="flaticon-conversation"></i>
                                <img src="assets/img/home-one/11.png" alt="Shape">
                            </div>
                            <h3>Quick Service</h3>
                            <p>We manage all valid papers and paperwork and continue to enter our path lawfully.</p>
                            <p>&nbsp;</p>
                        </li>
                    </ul>
               </div>
            </div>
        </div>
    </div>
</section>

<div class="about-area pt-50">
</div>